<template>
  <div class="c-keyboard" v-visible="!loading">
    <img class="background" :src="images.keyboard_75" @load="onLoad" />
    <div class="keys">
      <c-key
        v-for="(srcKey, index) in srcKeys"
        class="key"
        :class="{
          selected: selectedIndex === index,
          changed: !disabled && false,
          disabled: srcKey.disabled,
        }"
        :key="'srcKey' + index"
        :style="srcKey.style"
        :selected="selectedIndex === index"
        :profile="profile75"
        :layer="layer"
        :allKeys="allKeys"
        :dstKeys="dstKeys"
        :srcKey="srcKey"
        @click="
          !srcKey.disabled &&
            $emit('key-click', { index, keyIndex: srcKey.index })
        "
        @dblclick="
          !srcKey.disabled &&
            $emit('key-click', { index, keyIndex: srcKey.index })
        "
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { srcKeys, dstKeys } from "./Keyboard75";
import { allKeys } from "./VirtualKeyboard75";
import { deepCopy } from "@/utils";

export default {
  name: "CKeyboard75",
  props: {
    disabled: Boolean,
    selectedIndex: Number,
    layer: Array,
    layerIndex: Number,
  },
  data() {
    return {
      loading: true,
      srcKeys: deepCopy(srcKeys),
      dstKeys: deepCopy(dstKeys),
      allKeys,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState(["profile75"]),
  },
  watch: {
    layerIndex(layerIndex) {
      if (layerIndex === 1) {
        this.srcKeys[0] = {
          ...srcKeys[0],
          disabled: true,
        };
        // this.srcKeys[20] = {
        //   ...srcKeys[20],
        //   disabled: true,
        // };
      } else {
        this.srcKeys[0] = { ...srcKeys[0] };
        // this.srcKeys[20] = { ...srcKeys[20] };
      }
    },
  },
  methods: {
    getKey(srcKey) {
      return this.layer[srcKey.index];
    },
    onLoad() {
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.c-keyboard {
  width: 100%;
  position: relative;

  .background {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-user-drag: none;
  }

  .keys {
    width: 82.8%;
    height: 47.4%;
    position: absolute;
    left: 8.6%;
    top: 19%;
    display: flex;
    flex-wrap: wrap;

    .key {
      width: 4%;
      height: 12.5%;
      padding: 0 0.2%;
      font-size: 22px;
    }
  }
}
</style>
